import React from "react";

const CloseIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({className, ...props}) => (
  <svg
    className={className}
    viewBox="0 0 20 20"
    fill="none"
    role="img"
    focusable="false"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.29303 4.29299C4.48056 4.10552 4.73487 4.0002 5.00003 4.0002C5.26519 4.0002 5.5195 4.10552 5.70703 4.29299L10 8.58599L14.293 4.29299C14.3853 4.19748 14.4956 4.1213 14.6176 4.06889C14.7396 4.01648 14.8709 3.98889 15.0036 3.98774C15.1364 3.98659 15.2681 4.01189 15.391 4.06217C15.5139 4.11245 15.6255 4.1867 15.7194 4.28059C15.8133 4.37449 15.8876 4.48614 15.9379 4.60904C15.9881 4.73193 16.0134 4.86361 16.0123 4.99639C16.0111 5.12917 15.9835 5.26039 15.9311 5.38239C15.8787 5.5044 15.8025 5.61474 15.707 5.70699L11.414 9.99999L15.707 14.293C15.8892 14.4816 15.99 14.7342 15.9877 14.9964C15.9854 15.2586 15.8803 15.5094 15.6948 15.6948C15.5094 15.8802 15.2586 15.9854 14.9964 15.9877C14.7342 15.9899 14.4816 15.8891 14.293 15.707L10 11.414L5.70703 15.707C5.51843 15.8891 5.26583 15.9899 5.00363 15.9877C4.74143 15.9854 4.49062 15.8802 4.30521 15.6948C4.1198 15.5094 4.01463 15.2586 4.01236 14.9964C4.01008 14.7342 4.11087 14.4816 4.29303 14.293L8.58603 9.99999L4.29303 5.70699C4.10556 5.51946 4.00024 5.26515 4.00024 4.99999C4.00024 4.73483 4.10556 4.48052 4.29303 4.29299Z"
      fill="currentColor"
    />
  </svg>
);

export default CloseIcon;